import { HeaderCellProps } from '../types';

export const TenantCsmHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>CSM</div>;
};
